

















import { Vue, Component, Model, Prop } from "vue-property-decorator";
import DefinitionsAPI from "@/services/definitions";
import { DefinitionList } from "@/models/definition";

@Component
export default class DefinitionListSelector extends Vue {
  @Model("change") value?: string[] | string;
  @Prop({ default: "components.definitions_list_selector.label" })
  label!: boolean;
  @Prop({ default: () => [] }) rules!: boolean[];
  @Prop({ default: true }) multiple!: boolean;
  @Prop({ default: true }) dense!: boolean;

  definitons: DefinitionList[] = [];
  loading = true;

  created(): void {
    this.getDefinitions();
  }

  // async getSites(): Promise<void> {
  //
  // try {
  //   this.loading = true;
  //   this.sites = await SitesAPI.getSites();
  // } catch (error) {
  //   console.log(error);
  // } finally {
  //   this.loading = false;
  // }
  async getDefinitions(): Promise<void> {
    try {
      this.loading = true;
      const r = await DefinitionsAPI.list();
      this.definitons = r.data;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
}
